<script setup>
import { computed } from 'vue';

const props = defineProps({ category: { type: Object, required: true } });
const color = computed(() =>
  /^#[0-9a-f]{6}$/i.test(props.category.color)
    ? props.category.color
    : '#64748B'
);
</script>

<template>
  <span
    class="inline-flex max-w-full items-center gap-1.5 rounded-md border px-2 py-0.5 text-xs font-medium text-n-slate-12"
    :style="{ backgroundColor: `${color}20`, borderColor: `${color}66` }"
  >
    <span
      aria-hidden="true"
      class="size-1.5 shrink-0 rounded-full"
      :style="{ backgroundColor: color }"
    />
    <span class="truncate">{{ category.name }}</span>
  </span>
</template>
